import Controller from 'controllers/controller';
import Bus from 'tools/bus';
import jQuery from 'jquery';
import Binder from 'tools/binder';


class LoaderController extends Controller {
    constructor(app) {
        super(app);
        
        this.bus = new Bus(this);
        this.binder = new Binder(this);
    }
    
    loadPages() {
        this.app.pageController.pages.forEach(page => {
            this.loadPage(page);
        });
    }

    async loadPage(page) {
        let isCurrent = page.element.classList.contains('current-page');
        
        if ( ! isCurrent) {
            // A random number added to the page path since bites section images where incorrectly shown due to caching
            let html = await jQuery.get(`${APP_ROOT}ajax/?action=load-page&path=${page.path}&v=${Math.random()}`);

            page.element.innerHTML = html;
        }

        console.log('page loaded: ' + page.path);
        
        this.emit('page-loaded', page);
        this.emit(page.template + '-loaded', page);
        
        // Also emit event on app bus
        this.app.emit(page.template + '-loaded', page);
        this.app.emit('page-loaded', page);
    }
}

export default LoaderController;